<template>
  <v-list-item class="px-0">
    <SoAvatar
      ref="avatar"
      :type="currentAccount.account.data.status.type"
    ></SoAvatar>
  </v-list-item>
  <v-list-item class="px-0 mt-3" data-testid="primary-contact">
    <div class="font-size-align d-block text-truncate">
      {{ primaryContact?.fullName }}
    </div>
  </v-list-item>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAvatar from "@/components/SoAvatar.vue"

  import { useCurrentAccountStore } from "@/stores/currentAccount"

  export default defineComponent({
    components: {
      SoAvatar,
    },
    data() {
      return {
        currentAccount: useCurrentAccountStore(),
      }
    },
    computed: {
      primaryContact() {
        return this.currentAccount.accountContacts.data.find(
          (contact) => contact.juniferPrimaryContact,
        )
      },
    },
  })
</script>

<style lang="css" scoped>
  .font-size-align {
    font-size: 1.125rem;
    font-weight: bold;
  }
</style>
